import angular from 'angular';
import sendSms from './sendSms';
import './style.scss';

export default angular
  .module('components.sendSms', [])
  .component('sendSms', sendSms).name;
